import dayjs from '~/timeInit';

import type { Campaign } from './data';
import { sum } from './model';

/** TO_JSON_STRING emits BigQuery BIGNUMERIC as decimal text. Decode only a
 * finite decimal for presentation; the warehouse retains precision for ranking. */
export function metadataNumber(value: number | string | null | undefined): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string' || !/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(value.trim())) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
export function topOpportunities(campaigns: Campaign[], onlyTop50: boolean) {
  return onlyTop50
    ? campaigns
        .filter((c) => (c.source_top50_rank ?? Infinity) <= 50)
        .sort((a, b) => (a.source_top50_rank ?? 0) - (b.source_top50_rank ?? 0))
    : campaigns;
}
export function opportunityValues(campaign: Campaign, currencyMode: string, refund: string, selectedCurrency?: string) {
  const rows = (campaign.currency_metrics || []).filter(
    (row) =>
      !selectedCurrency || (currencyMode === 'AUD' ? selectedCurrency === 'AUD' : row.currency === selectedCurrency),
  );
  const currencies = new Set(rows.map((row) => row.currency).filter(Boolean));
  const revenue =
    currencyMode === 'AUD'
      ? sum(rows, (row) => row.revenue_aud)
      : currencies.size === 1
        ? sum(rows, (row) => row.revenue_vendor)
        : null;
  const sale = sum(rows, (row) => row.nights_sale),
    refunded = sum(rows, (row) => row.nights_refund);
  return {
    revenue,
    nights: sale === null ? null : refund === 'After Refund' ? (refunded === null ? null : sale - refunded) : sale,
    currency: currencyMode === 'AUD' ? 'AUD' : [...currencies].join(' / '),
  };
}
export function defaultPeriods(campaign: Campaign, today: string) {
  const add = (date: string, offset: number) => dayjs(date).add(offset, 'day').format('YYYY-MM-DD');
  const end =
    campaign.scheduled_end_date && dayjs(campaign.scheduled_end_date).isValid() && campaign.scheduled_end_date < today
      ? campaign.scheduled_end_date
      : add(today, -1);
  return { from: add(end, -55), to: end, cmpFrom: add(end, -111), cmpTo: add(end, -56) };
}
